<template>
  <div class="divider"></div>
  <!-- </transition> -->
</template>

<script>
export default {
  name: "DividerTwo",

  setup() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.divider {
  width: 100%;
  height: 1066px;
  margin-top: -219px;
  background-image: url("~images/players-cropped.png");
  background-position: center;
  background-size: cover;

  @media screen and (max-width: 789px) {
    height: 285px;
    margin-top: -127px;
  }
}
</style>
